// @ts-nocheck
import React from 'react';

import './styles.scss';

type Props = {
  icon?: string;
  id: string;
  label: string;
  multiDetailId?: string;
  totalValue?: string;
  value: string;
};

function MultiDetails({ icon, id, label, multiDetailId, totalValue, value }: Props) {
  return (
    <div className="multiDetails" id={id}>
      {icon && <i className={`${icon} multiDetails__icon`} />}
      <h4 className="multiDetails__value">
        {value}
        {multiDetailId === 'totalCampaigns' && <span className="multiDetails__totalSelected">{`/${totalValue}`}</span>}
      </h4>
      <span>{label}</span>
    </div>
  );
}

export default MultiDetails;
